import { Block, Typography } from '@xprog/prensa'
import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'

interface ArticleAudioProps {
  audioLink?: string
}

const ArticleAudioComponent: React.FC<ArticleAudioProps> = ({ audioLink }) => {
  const [playerKey, setPlayerKey] = useState(0)
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null)
  const [preloadAttr, setPreloadAttr] = useState<'none' | 'metadata'>('none')

  useEffect(() => {
    if (!audioLink) {
      setIsAvailable(false)
      return
    }
    let mounted = true
    const audio = new Audio(audioLink)
    audio.preload = 'none'

    audio.addEventListener('loadedmetadata', () => {
      if (!mounted) return
      setIsAvailable(true)
      setPreloadAttr('metadata')
      
      setPlayerKey((k) => k + 1)
    })
    audio.addEventListener('error', () => {
      if (mounted) setIsAvailable(false)
    })
    audio.load()

    return () => {
      mounted = false
      audio.remove()
    }
  }, [audioLink])

  // 2) Key adicional só para resize
  useEffect(() => {
    const onResize = () => setPlayerKey((k) => k + 1)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  // 3) Enquanto checa ou se deu erro, nada
  if (isAvailable === null) return null
  if (!isAvailable) return null

  // 4) Player com preload de metadados
  return (
    <Block
      css={{
        align: ['column', 'left', 'middle'],
        width: '100%',
        flexDirection: 'column',
        mb: '$8',
        pr: '$8',
        pl: '$4',
      }}
    >
      <Typography
        as='span'
        css={{
          fontFamily: '$primary',
          fontSize: '14px',
          mb: '$3',
        }}
      >
        ouvir matéria
      </Typography>
      <ReactPlayer
        key={playerKey}
        url={audioLink}
        controls
        playing={false}
        width='100%'
        height='50px'
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload',
              preload: preloadAttr, 
            },
          },
        }}
      />
    </Block>
  )
}

export default ArticleAudioComponent
